(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-block-options"] && !Shopify.designMode) return;
  try {
    /* Keeps "Size: S (36 - adult)" in the heading in sync with the selection */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.size-buttons input, .color-swatches input')) return;
    var group = input.closest('[data-option-group]');
    var out = group && group.querySelector('[data-selected-value]');
    if (out) out.textContent = input.dataset.label || input.value;
  });
  } catch(e) { console.error(e); }
})();

})();
